import { render, staticRenderFns } from "./prijectDialog.vue?vue&type=template&id=7e85421a&scoped=true&"
import script from "./prijectDialog.vue?vue&type=script&lang=js&"
export * from "./prijectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e85421a",
  null
  
)

export default component.exports